import React, { ReactElement } from 'react'
import { makeStyles } from '@material-ui/core/styles'
import { IGatsbyImageData } from 'gatsby-plugin-image'
import ImageSource from './ImageSource'

const useStyles = makeStyles(theme => ({
  image: {
    display: 'inline-block',
    margin: theme.spacing(1.5, 1, 0, 0)
  }
}))

export interface ImageProps {
  imageId: string
  gatsbyImage?: IGatsbyImageData
}

/* 
This component is using a replacement component called: ImageSource instead of GatsbyImage.
There is a loading bug in the GatsbyImage component within Safari when hosted in an iframe.
This bug causes the placeholder to be shown instead of the actual image.
If this bug is resolved, you can replace this component with this:
<GatsbyImage
  className={classes.image}
  image={gatsbyImage}
  alt={`image-${imageId}`}
  />
*/
function Image({ imageId, gatsbyImage }: ImageProps): ReactElement {
  const classes = useStyles()
  return <ImageSource className={classes.image} imageId={imageId} image={gatsbyImage} />
}

export default Image
